import { render, staticRenderFns } from "./MicroLesson.vue?vue&type=template&id=ae7c561a&scoped=true"
import script from "./MicroLesson.vue?vue&type=script&lang=js"
export * from "./MicroLesson.vue?vue&type=script&lang=js"
import style0 from "./MicroLesson.vue?vue&type=style&index=0&id=ae7c561a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7c561a",
  null
  
)

export default component.exports